<template>
	<div class="useCard">
		<van-nav-bar
			:title="mallInfo.couponName"
			left-arrow
			@click-left="$router.back()"
		/>
		<van-tabs v-model="active">
			<van-tab title="实体券">
				<van-form @submit="shiSubmit">
					<van-cell-group style="margin-top: 10px">
						<van-field v-model="form.cardNum" placeholder="请输入券号" />
					</van-cell-group>
					<van-cell-group style="margin-bottom: 10px">
						<van-field v-model="form.cardPassword" placeholder="请输入密码" />
					</van-cell-group>
					<!-- <div style="padding: 20px">
						<van-checkbox
							v-model="checked"
							icon-size="16px"
							checked-color="#ee0a24"
						>
							<div>
								<span style="color: #797d82; margin-right: 10px"
									>我已阅读并同意</span
								>
								<span @click="$router.push('/qzz')" style="color: #96b2e7"
									>券章程</span
								>
							</div>
						</van-checkbox>
					</div> -->
					<van-cell-group style="margin-bottom: 10px">
						<div style="padding: 10px">
							<van-button type="danger" color="#c03131" block
								>立即绑定</van-button
							>
						</div>
					</van-cell-group>
				</van-form>
			</van-tab>
			<van-tab title="电子券">
				<van-form @submit="dianSubmit">
					<van-cell-group style="margin-bottom: 10px">
						<van-field v-model="dian" placeholder="请输入电子码" />
					</van-cell-group>
					<!-- <div style="padding: 20px">
						<van-checkbox
							v-model="checked"
							icon-size="16px"
							checked-color="#ee0a24"
						>
							<div>
								<span style="color: #797d82; margin-right: 10px"
									>我已阅读并同意</span
								>
								<span @click="$router.push('/qzz')" style="color: #96b2e7"
									>券章程</span
								>
							</div>
						</van-checkbox>
					</div> -->
					<van-cell-group style="margin-bottom: 10px">
						<div style="padding: 10px">
							<van-button type="danger" color="#c03131" block
								>立即绑定</van-button
							>
						</div>
					</van-cell-group>
				</van-form>
			</van-tab>
		</van-tabs>
	</div>
</template>

<script>
import { cardBind, cardCheckNtoken } from "@/utils/api.js";
export default {
	data() {
		return {
			active: 0,
			form: {},
			checked: false,
			dian: "",
			userInfo: {},
			item: "",
			couponName: "",
			mobile: "",
			mallInfo: {},
		};
	},
	created() {
		this.couponName = this.$route.query.couponName;
		this.mobile = this.$route.query.mobile;
		this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
		this.mallInfo = JSON.parse(localStorage.getItem("mallInfo"));
	},
	methods: {
		async shiSubmit() {
			if (!this.form.cardNum && !this.form.cardPassword) return;
			//	if (!this.checked) return this.$toast("请勾选阅读并同意(券章程)");
			let params = JSON.parse(JSON.stringify(this.form));
			params.mobile = this.mobile;
			//  卡券效验
			const res4 = await cardCheckNtoken(params);
			if (res4 && res4.elSign == 1) {
				sessionStorage.setItem("cardPassword", params.cardPassword);
				window.location = `${
					window.location.origin + "/shop"
				}/?t=${localStorage.getItem("t")}#/sign?cardId=${res4.cardId}&cardNum=${
					res4.cardNum
				}&tenantId=${res4.tenantId}&mallId=${res4.mallId}&mobile=${
					this.userInfo.mobile
				}&openid=${this.userInfo.openid}`;
				return;
			}
			const res = await cardBind(params);
			this.$toast.success(res.message);
			this.$router.back();
		},
		async dianSubmit() {
			if (!this.dian) return;
			//	if (!this.checked) return this.$toast("请勾选阅读并同意(券章程)");
			let params = {};
			params.cardNum = this.dian.slice(0, 10);
			params.cardPassword = this.dian.slice(11, 30);
			params.mobile = this.mobile;
			//  卡券效验
			const res4 = await cardCheckNtoken(params);
			if (res4 && res4.elSign == 1) {
				sessionStorage.setItem("cardPassword", params.cardPassword);
				window.location = `${
					window.location.origin + "/shop"
				}/?t=${localStorage.getItem("t")}#/sign?cardId=${res4.cardId}&cardNum=${
					res4.cardNum
				}&tenantId=${res4.tenantId}&mallId=${res4.mallId}&mobile=${
					this.userInfo.mobile
				}&openid=${this.userInfo.openid}`;
				return;
			}
			const res = await cardBind(params);
			this.$toast.success(res.message);
			this.$router.back();
		},
	},
};
</script>

<style lang="scss" scoped>
.useCard {
	font-size: 12px;
	background-color: #fff;
}
</style>